import React from "react";



const ProductCard=({
product,
index,
onReadMore
})=>{

const image = product.image_url || null
// tagline is the short-form field in the schema; description is the
// long form used in the modal, so the bento tile's brief caption uses
// tagline first and falls back to a trimmed description if it's blank.
const caption = product.tagline || product.description

return(

<div
className={`product-card card-${index+1}`}
>


{image
? <img
    src={image}
    alt={product.name}
  />
: <div className='product-card-placeholder'></div>
}


<div className="product-overlay">


<h3>
{product.name}
</h3>


<p>
{caption}
</p>



<button
onClick={onReadMore}
>
Read More
</button>


</div>


</div>


)


}


export default ProductCard;